import { CLASSIFICATION_CUBE_NAME } from '@/api/hcp';
import { GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfigDynamic } from '@/types/filter';
import { toStringOrNull } from '@/utils/cube';

const TAE_AREA_OPTIONS: GetOptionsQueryFunction = ({ sourceCube }) => ({
  dimensions: [`${sourceCube}.global_indication_name`],
  limit: undefined,
});

const indicationFilter: FilterConfigDynamic = {
  label: 'global.filters.formControls.taIndicationsLabel',
  sourceCube: CLASSIFICATION_CUBE_NAME,
  defaultValue: [],
  getOptionsQuery: TAE_AREA_OPTIONS,
  mapResult: result => {
    const value = toStringOrNull(result[`${CLASSIFICATION_CUBE_NAME}.global_indication_name`]);
    if (value === null) return null;
    return { value, label: value };
  },
  type: 'multiselect',
  clearable: true,
  placeholder: 'global.filters.formControls.taIndicationsPlaceholder',
  format: ({ value }) => {
    const v = value as string;
    return v === 'other' ? 'Other' : v;
  },
  searchable: true,
  applyFilter: value => {
    const v = value as string[];
    return {
      member: `${CLASSIFICATION_CUBE_NAME}.global_indication_name`,
      operator: 'equals',
      values: [...v],
    };
  },
};

export default indicationFilter;
